import { BehaviorSubject } from 'rxjs';
import { cloneDeep, isEqual } from 'lodash';

import { WatchFunnelService } from './../../../../../services/watch-funnel.service';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FunnelService } from '../../../../../services/funnel.service';
import { IFunnelStepVariation } from '../../../../../interfaces/graph-types';
import { SmartButtonComponent } from '../../../../shared/smartbutton/smartbutton.component';

@Component({
  selector: '[account-funnel-step-wait]',
  template: require('./account-funnel-step-wait.component.pug'),
  styles: [require('./account-funnel-step-wait.component.css').toString()],
})
export class AccountFunnelStepWaitComponent implements OnInit {
  @Input()
  formDirty: boolean;
  @Input()
  datafeed: BehaviorSubject<IFunnelStepVariation>;
  @Input()
  baseVariation: BehaviorSubject<IFunnelStepVariation>;
  @Output()
  cancel = new EventEmitter();
  @Output()
  onUpdate: EventEmitter<void> = new EventEmitter();
  @Output()
  onDelete: EventEmitter<void> = new EventEmitter();
  @Output()
  onFormModified = new EventEmitter<boolean>();
  @ViewChild(SmartButtonComponent, { static: true })
  saveButton: SmartButtonComponent;

  sub: any = null;

  info: IFunnelStepVariation;
  initialInfo: IFunnelStepVariation;

  private funnel_id: string = null;
  campsub: any = null;

  // -------------------------------------------------------------------
  constructor(
    private funnelService: FunnelService,
    private watch: WatchFunnelService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.sub = this.datafeed.subscribe(data => {
      this.info = cloneDeep(data || {});
      this.initialInfo = cloneDeep(this.info);

      if (this.info.unit == null) {
        this.info.unit = 'days';
      }
      if (this.info.value == null) {
        this.info.value = 3;
      }
      if (this.info.business == null) {
        this.info.business = true;
      }
      this.saveButton.loading = false;
    });

    this.campsub = this.watch.funnelId().subscribe(funnel_id => {
      this.funnel_id = funnel_id;
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.campsub) {
      this.campsub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  handleFormElementChange() {
    const hasFormChanged = !isEqual(this.info, this.initialInfo);
    this.onFormModified.emit(hasFormChanged);
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.cancel.emit(null);
  }

  // -------------------------------------------------------------------
  getTitle() {
    if (this.info.id) {
      return 'Update step';
    }
    return 'Create step';
  }

  // -------------------------------------------------------------------
  withTimeTable(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.info.business = !this.info.business;
    this.handleFormElementChange();
    onsuccess();
  }

  // -------------------------------------------------------------------
  delete(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.funnelService.deleteStepVariation(
      this.info.id,
      () => {
        this.onDelete.emit();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  onHoursClick() {
    this.info.unit = 'hours';
    this.handleFormElementChange();
  }

  // -------------------------------------------------------------------
  onDaysClick() {
    this.info.unit = 'days';
    this.handleFormElementChange();
  }

  // -------------------------------------------------------------------
  onMinutesClick() {
    this.info.unit = 'minutes';
    this.handleFormElementChange();
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    if (!this.funnel_id) {
      console.log('Funnel id unknown');
      onfailure('Unknown funnel id');
      return;
    }

    let baseVariationId = null;
    if (this.baseVariation.getValue()) {
      baseVariationId = this.baseVariation.getValue().id;
    }

    this.funnelService.createOrUpdateWaitStep(
      baseVariationId,
      this.funnel_id,
      this.info.id,
      this.info.unit,
      this.info.value,
      this.info.business,
      data => {
        this.onUpdate.emit(data.stepVariationId);
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  deleteTagCondition(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.funnelService.deleteConditionTags(
      [data.id],
      data => {
        this.onUpdate.emit(data.stepVariationId);
      },
      error => {
        onfailure(error);
      },
    );
  }
}
